export { default } from './CarInfos';
